import { useRetailPrices } from './useRetailPrices';

/** Independent administrator-set prices; no conversion on page load. */
export function useDisplayCurrency(locale: 'tr' | 'en') {
  const { price, error, retry } = useRetailPrices();
  const format = (key: string) => {
    const amount = key === 'plan:Free' ? 0 : price(key)?.[locale === 'tr' ? 'try' : 'usd'];
    if (amount === undefined || !Number.isFinite(amount)) return null;
    return new Intl.NumberFormat(locale === 'tr' ? 'tr-TR' : 'en-US', {
      style: 'currency', currency: locale === 'tr' ? 'TRY' : 'USD', minimumFractionDigits: 2, maximumFractionDigits: 2,
    }).format(amount);
  };
  return { format, error, retry };
}
